module.exports = __webpack_public_path__ + "img/25.49c10de9.png";